import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import "./NewsManagement.css";

const NewsManagementPage = () => {
  const [newsList, setNewsList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingNews, setEditingNews] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    setNewsList([
      {
        id: 1,
        title: "News 1",
        author: "Admin",
        date: "2025-02-27",
        description: "This is a sample news description.",
        coverImage: null,
        attachments: [],
      },
      {
        id: 2,
        title: "News 2",
        author: "Admin",
        date: "2025-02-26",
        description: "Another news article here.",
        coverImage: null,
        attachments: [],
      },
    ]);
  }, []);

  const showModal = (news = null) => {
    setEditingNews(news);
    setIsModalOpen(true);
    if (news) {
      form.setFieldsValue(news);
    } else {
      form.resetFields();
    }
  };

  const handleDelete = (id) => {
    setNewsList(newsList.filter((news) => news.id !== id));
    message.success("News deleted successfully!");
  };

  const handleSave = (values) => {
    const coverImage = values.coverImage?.file?.name || null;
    const attachments =
      values.attachments?.fileList.map((file) => file.name) || [];

    if (editingNews) {
      setNewsList((prev) =>
        prev.map((news) =>
          news.id === editingNews.id
            ? { ...news, ...values, coverImage, attachments }
            : news
        )
      );
      message.success("News updated successfully!");
    } else {
      const newNews = {
        id: newsList.length + 1,
        ...values,
        date: new Date().toISOString().split("T")[0], // Current date
        coverImage,
        attachments,
      };
      setNewsList([...newsList, newNews]);
      message.success("News added successfully!");
    }
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="layout news-management-layout">
        <h1>News Management</h1>
        <Button className="button-primary" onClick={() => showModal()}>
          Add News
        </Button>
        <Table
          className="news-table"
          dataSource={newsList}
          columns={[
            { title: "Title", dataIndex: "title", key: "title" },
            { title: "Author", dataIndex: "author", key: "author" },
            { title: "Date", dataIndex: "date", key: "date" },
            {
              title: "Actions",
              render: (_, record) => (
                <>
                  <Button onClick={() => showModal(record)}>Edit</Button>
                  <Button danger onClick={() => handleDelete(record.id)}>
                    Delete
                  </Button>
                </>
              ),
            },
          ]}
          rowKey="id"
        />

        <Modal
          title={editingNews ? "Edit News" : "Add News"}
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onOk={() => form.submit()}
        >
          <Form form={form} layout="vertical" onFinish={handleSave}>
            <Form.Item name="title" label="Title" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item
              name="author"
              label="Author"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="description" label="Description">
              <Input.TextArea rows={4} />
            </Form.Item>
            <Form.Item name="coverImage" label="Cover Image">
              <Upload
                listType="picture"
                maxCount={1}
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />}>Upload Cover Image</Button>
              </Upload>
            </Form.Item>
            <Form.Item name="attachments" label="Image Attachments">
              <Upload listType="picture" multiple beforeUpload={() => false}>
                <Button icon={<UploadOutlined />}>Upload Attachments</Button>
              </Upload>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default NewsManagementPage;
